import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "1748",
  height: "2912",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m973 2911 579-931L2 1012l461-294L1747 1",
      stroke: "url(#a)",
      "stroke-opacity": ".3",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "a",
        x1: "2112.7",
        y1: "-564.6",
        x2: "-1035.4",
        y2: "2557.4",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", {
          "stop-color": "#001A78",
          "stop-opacity": "0"
        }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#596294"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }